// extracted by mini-css-extract-plugin
export default {"datePicker":"EditProjectStoryModal_datePicker__2rtGb","label":"EditProjectStoryModal_label__xXdS2","datePickerInput":"EditProjectStoryModal_datePickerInput__lmmIV"};